import { setApolloState } from '../lib/ApolloSchema/apolloUtils';
export var emptyErrorState = {
  uiData: {
    errorMessage: ''
  }
};

/**
 * Removes any UI error messaging from Apollo state
 */
export var onCloseNotificationBanner = function onCloseNotificationBanner() {
  setApolloState(emptyErrorState);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/NotificationBannerUtil.js
// module id = 4360
// module chunks = 11